import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { SalesReportResponseV4Schema } from "../response/SalesReportResponseV4";
import { SalesReportFilterV4Type } from "../schema/SalesReportFilterSchemaV4";

const API_VERSION = 'v4';

interface SalesReportV4Props {
    filter?: SalesReportFilterV4Type;
    orderBy?: string;
    sort?: 'asc' | 'desc';
    type: string | null;
}

const useSalesReportV4 = (params: SalesReportV4Props) => {
    return useQuery({
        queryKey: [
            'report',
            'group-sales-report',
            API_VERSION,
            params.type,
            JSON.stringify(params.filter),
            params.orderBy,
            params.sort,
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.post(`/${API_VERSION}/channel-manager/group-report-sales`, {
                    filter: params.filter,
                    orderBy: params.orderBy,
                    sort: params.sort,
                });

                const validationResult = SalesReportResponseV4Schema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Sales report V4 data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Sales report V4`, error);
                throw error;
            }
        },
        enabled: !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date && !!params.filter.base_on && params.type === "sales_report",
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useSalesReportV4;